const [ w, d ] = [ window, document ]

const init = () => {

  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-recruit[data-plugin="currentMenu"]').currentMenu({ mode: 0 })
    })
  }

    //スロット適用
    $.when( w.load['recruit-entry'] ).then( ( html, slot ) => {
      let $obj = $( '[data-slot="recruit-mynavi"]' )
      slot = slot.replace(/<!--[^-]+-->/gm,'');
      if( slot ){
        let $slot = $('<div class="recruit-entry__btnwrap is-mynavi">')
        $slot.append( slot )
        $obj.replaceWith( $slot )
      } else {
        $obj.hide()
      }
    })

}

export default function RECRUIT() {
  $( init )
}